import {Component, OnDestroy, OnInit} from '@angular/core';
import {PageLayoutService, ProductListComponent, ProductListComponentService, ViewConfig} from '@spartacus/storefront';
import {Observable} from 'rxjs';
import {GlobalMessageService, ProductSearchPage} from '@spartacus/core';

@Component({
  selector: 'dcp-dcp-search-product',
  template: '',
})
export class DcpSearchProductComponent extends ProductListComponent implements OnInit, OnDestroy {

  model$: Observable<ProductSearchPage>;

  constructor(
    pageLayoutService: PageLayoutService,
    productListComponentService: ProductListComponentService,
    globalMessageService: GlobalMessageService,
    public scrollConfig: ViewConfig
  ) {
    super(pageLayoutService, productListComponentService, globalMessageService, scrollConfig);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
